// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CKA3l","quoteAcknowledgementAlert":"styles_quoteAcknowledgementAlert__dY3Mv","action":"styles_action__BdI35"};